export default "__VITE_ASSET__D79EgR32__"